import { ContentfulEvent, type WebSection } from '@wbk/contentful/api';
import { Link, useRouter } from '@wbk/config';
import { useAnalytics } from '@wbk/analytics';
import { parseSectionItem } from '@wbk/contentful';
import { Button } from '@wbk/ui';
import { getEventRedirectUrl } from '@/utils/redirect';
import EventCard from '@/components/events/EventCard';

type Props = {
  item: WebSection['contentCollection']['items'][0] | ContentfulEvent;
  index: number;
  section: WebSection;
};

const EventCardItem = ({ item, section, index }: Props) => {
  const { trackEvent } = useAnalytics();
  const { locale } = useRouter();
  const parsedItem = parseSectionItem({
    // @ts-expect-error - because item type can be ContentfulEvent and parseSectionItem expects a generic WebSectionItem type
    item,
    locale,
  });
  if (!parsedItem) return null;
  const parsed = parsedItem;

  const redirectInfo = getEventRedirectUrl(item, 'slug' in item ? item.slug : '', locale, parsed);

  return (
    <Button
      as={Link}
      href={redirectInfo.href}
      target={redirectInfo.isExternal ? '_blank' : undefined}
      theme='white'
      shape='text'
      className='h-full w-full p-0'
      onClick={() => {
        trackEvent({
          event: 'clicked_on_section_item',
          data: {
            type: item.__typename,
            slug: 'slug' in item ? item.slug : '',
            section: section.id,
            position: index,
          },
        });
      }}
      rel='noreferrer'
    >
      <EventCard
        eventType={parsedItem?.eventType}
        venueName={parsed.title}
        eventDate={parsed.date || ''}
        priceFrom={parsed.startingPrice}
        currency={parsed.currencyCode}
        image={parsed.image11}
        // @ts-expect-error -- zone object exists but not typed
        zoneLogo={parsed?.zone?.zoneLogo}
        buttonText={parsed?.label || undefined}
      />
    </Button>
  );
};

export default EventCardItem;
